import * as moment from 'moment';
import { FormControl, Validators } from '@angular/forms';
import { functonLabel, IDateRange, IMachineFromApi, MachineFunction } from 'app/models';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-filter-component',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit, OnChanges {
  @Input()
  listOfMachinesFromApi: Array<IMachineFromApi> = [];

  @Input()
  selectedMachine: IMachineFromApi | null = null;

  @Output()
  selectedMachineChanged = new EventEmitter<number>();

  @Output()
  filterByDateChanged = new EventEmitter<IDateRange>();

  functonLabel = functonLabel;

  disabled = true;
  listOfMachines: Array<IMachineFromApi> = [];
  operations: string[] = Object.values(MachineFunction);
  selectedOperation = 'All';
  startDate = new FormControl(
    { value: moment().startOf('day'), disabled: this.disabled },
    Validators.required
  );
  endDate = new FormControl(
    { value: moment().endOf('day'), disabled: this.disabled },
    Validators.required
  );

  ngOnInit(): void {
    this.listOfMachines = this.listOfMachinesFromApi;
  }

  ngOnChanges(changes: any): void {
    if (changes.listOfMachinesFromApi) {
      this.listOfMachines = changes.listOfMachinesFromApi.currentValue;
    }
    if (changes.selectedMachine) {
      this.selectedMachine = changes.selectedMachine.currentValue;
    }
  }

  handleSelectChange() {
    this.disabled = true;
    this.selectedMachineChanged.emit();
    if (this.selectedOperation === 'All') {
      this.listOfMachines = this.listOfMachinesFromApi;
    } else {
      this.listOfMachines = this.listOfMachinesFromApi.filter(
        (machine) => machine.function === this.selectedOperation
      );

      this.startDate.disable();
      this.endDate.disable();
    }
  }

  handleRadioChange({ target }: Event) {
    const selectedMachineId = Number((target as HTMLElement).id);

    this.selectedMachineChanged.emit(selectedMachineId);
    this.handleFilterByDateChanged();

    this.disabled = false;
    this.startDate.enable();
    this.endDate.enable();
  }

  handleFilterByDateChanged(): void {
    this.filterByDateChanged.emit({
      startDate: moment(this.startDate.value).startOf('day'),
      endDate: moment(this.endDate.value).endOf('day'),
    });
  }
}
